define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare, _, Controller, locale, MessageDialog, xml) {

	var INCOMPLETE = "SRV_ERR_SiteAdmin_SELECT_SET_GENERATE_PDF_INCOMPLETE";

	return declare(Controller, {

		// Boolean: publish request immediately
		bHold: false,

		// Boolean: indicates if confirming action
		_bConfirm: false,

		confirmAction: function(/*Object*/params) {
			//summary: customize buttons
			params.buttons = [MessageDialog.BUTTON_GENERATE_ANYWAY + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: initialize fields from user settings
			view.addDefaultValue("Locale", locale.getLocale());
			this.inherited(arguments);
		},

		onConfirm: function(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_GENERATE_ANYWAY) {
				this.process();
			} else {
				this.postProcess();
			}
		},

		toWriterRequest: function() {
			var call = this.inherited(arguments);

			if (this._bConfirm) {
				call.addParameter("Force", xml.ATTR_BOOLEAN, true);
				call.addParameter("Locale", xml.ATTR_STRING, this.popupView.getFieldValue("Locale"));
			}

			return call;
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: if error code signals incomplete size map, then prompt if they want to force active
			var node = this.getNode();
			if (this._isProduct(node) && this._errorCode == INCOMPLETE) {
				this._bConfirm = true;
				var error = this.getError();
				var errorParams = {
					//exception: this._errorException,
					onResponse: false
				};
				if (!errorParams.message && !errorParams.suffix) {
					errorParams.message = error;
				}
				this.confirmAction(errorParams);
				this._errorCode = null;
			} else {
				this.inherited(arguments);
			}
		},

		_isProduct: function(node) {
			return node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style" || node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Material";
		}

	});
});
